import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepperComponent implements OnInit {

  @Input() totalSteps: number = 2;
  @Input() currentStep: number = 1

  constructor() { }

  ngOnInit(): void {
  }

  get steps(): number[] {
    return Array.from({ length: this.totalSteps }, (_, i) => i + 1);
  }

  get progress(): number {
    let progress;
    if (this.totalSteps <= 1) progress = 0;
    progress = ((this.currentStep - 1) / (this.totalSteps - 1)) * 100;
    return progress;
  }

}
